/**
 * @generated SignedSource<<6d3aac6922bc725a1f8a65b63d306962>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SitemapManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SitemapNode",
        "kind": "LinkedField",
        "name": "sitemapRoots",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Sitemap_sitemapRoots"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SitemapManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SitemapNode",
        "kind": "LinkedField",
        "name": "sitemapRoots",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SitemapNode",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SitemapNode",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SitemapNode",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SitemapNode",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SitemapNode",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": true,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SitemapNode",
                                "kind": "LinkedField",
                                "name": "children",
                                "plural": true,
                                "selections": [
                                  (v0/*: any*/),
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SitemapNode",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": true,
                                    "selections": [
                                      (v0/*: any*/),
                                      (v1/*: any*/),
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SitemapNode",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": true,
                                        "selections": [
                                          (v0/*: any*/),
                                          (v1/*: any*/),
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SitemapNode",
                                            "kind": "LinkedField",
                                            "name": "children",
                                            "plural": true,
                                            "selections": [
                                              (v0/*: any*/),
                                              (v1/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c04e0d3532dffebeca654ec2105869f",
    "id": null,
    "metadata": {},
    "name": "SitemapManagerQuery",
    "operationKind": "query",
    "text": "query SitemapManagerQuery {\n  sitemapRoots {\n    ...Sitemap_sitemapRoots\n    id\n  }\n}\n\nfragment Sitemap_sitemapRoots on SitemapNode {\n  id\n  title\n  resourcePath\n  children {\n    id\n    title\n    resourcePath\n    children {\n      id\n      title\n      resourcePath\n      children {\n        id\n        title\n        resourcePath\n        children {\n          id\n          title\n          resourcePath\n          children {\n            id\n            title\n            resourcePath\n            children {\n              id\n              title\n              resourcePath\n              children {\n                id\n                title\n                resourcePath\n                children {\n                  id\n                  title\n                  resourcePath\n                  children {\n                    id\n                    title\n                    resourcePath\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b66236376ca5a89cc94f5387d1312cc9";

module.exports = node;
